// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from 'plugins/http'
import { getData } from 'utils/get'

// send login data and retrive a new token
export const postLogin = ({ email, password }) =>
  http.post('/auth/login', { email, password })
  /**
   * functional approach, more readable and generate minus code
   * examples:
   * PromiseObject.then(response => response.data)
   * PromiseObject.then({ data } => data)
   *
   * We do this many times in many locations.
   * We know that .then accepts a function and what arguments it receives
   * This is because in JavaScript functions are first class citizens.
   * In summary we can pass functions as arguments and also receive functions as results
   * (first-class function and higher-order function)
   */
  .then(getData) // .then(response => getData(response))


  // send login data and retrive a new token
export const postByEmailLinkLogin = ({ }) =>
  http.post('/auth/loginbyemail/'.target, {})
  /**
   * functional approach, more readable and generate minus code
   * examples:
   * PromiseObject.then(response => response.data)
   * PromiseObject.then({ data } => data)
   *
   * We do this many times in many locations.
   * We know that .then accepts a function and what arguments it receives
   * This is because in JavaScript functions are first class citizens.
   * In summary we can pass functions as arguments and also receive functions as results
   * (first-class function and higher-order function)
   */
  .then(getData) // .then(response => getData(response))


  // send login data and retrive a new token
export const postLearningLogin = ({ email,target }) =>
  http.post('/auth/learning/login', { email,target })
  /**
   * functional approach, more readable and generate minus code
   * examples:
   * PromiseObject.then(response => response.data)
   * PromiseObject.then({ data } => data)
   *
   * We do this many times in many locations.
   * We know that .then accepts a function and what arguments it receives
   * This is because in JavaScript functions are first class citizens.
   * In summary we can pass functions as arguments and also receive functions as results
   * (first-class function and higher-order function)
   */
  .then(getData) // .then(response => getData(response))


  


//register user
export const postRegister = ({ first_name, last_name, designation, company, employee_count, country, timezone, email,                             password  }) =>
  http.post('/auth/register', { first_name, last_name, designation, company, employee_count, country, timezone, email, password  })
 .then(getData) // .then(response => getData(response))

// verify
export const postVerification = ({ id,token, secret }) => http.post('/auth/verify', { id, token, secret }).then(getData)


// get current user's data
export const loadUserData = () => http.get('/me').then(getData)

// revoke current token 
export const revokeToken = () => http.post('/auth/token/revoke').then(getData)

// checkCompanyLicense
export const checkCompanyLicense = (token) => http.post('/auth/validatelic',{'token':token}).then(getData)



// WEBPACK FOOTER //
// ./src/app/auth/services.js